import React, { FunctionComponent } from 'react';
import IPost from '@interfaces/IPost';
import css from './FeaturingPostPreview.module.less';
import { Carousel } from 'antd';
import Image from '@components/Image';
import UserShortCard from '@components/UserShortCard';
import TextWithHashtags from '@components/TextWithHashtags';
import cn from 'classnames';
import { CalendarOutlined, LeftCircleOutlined, RightCircleOutlined } from '@ant-design/icons';
import { get } from 'lodash';
import moment from 'moment';
import { FULL_TIME_FORMAT } from '@config/format';
import useTranslate from '@hooks/useTranslate';
import componentContent from '../FeaturingPage.module.json';
import ShowMore from '@fields/ShowMore/ShowMore';

// TODO https://github.com/akiran/react-slick/issues/623#issuecomment-629764816
const NextArrow = ({ currentSlide, slideCount, ...props }: any) => (
  <RightCircleOutlined {...props} />
);
const PrevArrow = ({ currentSlide, slideCount, ...props }: any) => (
  <LeftCircleOutlined {...props} />
);

const FeaturingPostPreview: FunctionComponent<{ post: IPost }> = ({ post }) => {
  const content = useTranslate(componentContent);

  return (
    <div className={css.root}>
      <div className={css.images}>
        {post.photos.length > 1 ? (
          <Carousel arrows={true} nextArrow={<NextArrow />} prevArrow={<PrevArrow />}>
            {post.photos.map((photo) => (
              <Image className={css.image} key={photo.photo} url={photo?.image?.url || ''} />
            ))}
          </Carousel>
        ) : (
          <Image
            className={css.image}
            key={post.files[0] ? post.files[0].image?.fileId : ''}
            url={post.files[0]?.image?.url || ''}
          />
        )}
      </div>
      <div className={css.content}>
        <div className={css.user}>
          <UserShortCard user={post.author} onClick={() => {}} />
        </div>

        <div className={css.body}>
          <ShowMore height={184}>
            <TextWithHashtags onHashtagClick={() => {}} source={post.tags}>
              {post.text}
            </TextWithHashtags>
          </ShowMore>
        </div>
        <div className={css.footer}>
          {post.playerID ? (
            <div className={css.gameId}>
              <span>{content.nickname}: </span>
              <span>{post.playerID.contact}</span>
            </div>
          ) : null}
          <div className={cn(css.metaLine, css.meta)}>
            <div className={css.metaLineItem}>
              <span>{get(post, ['game', 'name'], 'undefined')}</span>
            </div>
            <div className={css.metaLineItem}>
              <span className={css.metaIcon}>
                <CalendarOutlined />
              </span>
              <span>{moment(post.createdDateTime).format(FULL_TIME_FORMAT)}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturingPostPreview;
